import { useDispatch, useSelector } from "react-redux";
import SearchSelect from "../../../components/Inputs/SearchSelect";
import { ModalBase } from "../../../components/Modals/ModalBase";
import { State } from "../../../reducers";
import InputPhone from "../../../components/Inputs/InputPhone";
import { useEffect, useState } from "react";
import { getMunicipios } from "../../../actions/catalogos.actions";

export default function ModalClienteEncontradoDTE (props: any) {
  const {tipoDocumento, departamentos, municipios, actividadesEconomicas} = useSelector((state: State) => state.catalogos)
  const [catalogoActividadEconomica, ] = useState(actividadesEconomicas.map((tipo) => ({...tipo,codigo_nombre: `${tipo.codigo} - ${tipo.valor}`})))
  const dispatch = useDispatch()

  // useEffect(() => {
  //   if(props?.infoCliente?.departamento){
  //       dispatch(getMunicipios(props?.infoCliente?.departamento, departamentos.find((departamento) => departamento?.codigo === props?.infoCliente?.departamento)?.valor))
  //   }
  // }, [props?.infoCliente])

  useEffect(() => {
    const depto = departamentos.find((el) => el.codigo === props.infoCliente?.departamento)?.valor
    if (depto) dispatch(getMunicipios(Number(props.infoCliente?.departamento), depto, true))
    return () => {
      // close()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

    return (
        <ModalBase Styles={{maxWidth: '700px', width: '70%'}}>
          <div className='card w-form'>
            <form
              className='form-content'
              data-wf-page-id='64b58c72be2b65200b1e6fa6'
              data-wf-element-id='deb0f47f-468f-13fc-f1eb-4d36c39616dc'
            >
              <div>
                <h3 className='card-title l'>Cliente Encontrado</h3>
              </div>
              <span className='label-input'>
                Se encontró este cliente con la información ingresada. ¿Desea llenar la información?
              </span>
              <div className='w-layout-hflex h-inputs'>
                <div className='label-input'>
                  <label htmlFor='tipoDocumento' className='field-label m'>
                    Tipo de documento de identificación
                  </label>
                  <SearchSelect
                    defaultValue={null}
                    disabled={true}
                    placeholder='Tipo de Identificación'
                    value={props.infoCliente?.tipoDocumento}
                    name='tipoDocumento'
                    data={tipoDocumento}
                    keyNameText='valor'
                    keyNameValue='codigo'
                    onChange={(value: any) => {}}
                  />
                </div>
                <div className='label-input'>
                  <label htmlFor='numId' className='field-label m'>
                    {tipoDocumento?.find((el) => el.codigo === props.infoCliente?.tipoDocumento)?.valor}
                  </label>
                  <input
                    autoComplete='off'
                    type='text'
                    className='m text-field w-input'
                    name='numId'
                    data-name='numId'
                    id='numId'
                    disabled={true}
                    value={props.infoCliente?.numDocumento}
                  />
                </div>
              </div>
              <div className='w-layout-hflex h-inputs'>
                <div className='label-input'>
                  <label htmlFor='nombre' className='field-label m'>
                    Nombre del cliente
                  </label>
                  <input
                    autoComplete='off'
                    type='text'
                    className='m text-field w-input'
                    name='nombre'
                    data-name=''
                    placeholder='Nombre del cliente'
                    id='nombre'
                    disabled={true}
                    maxLength={250}
                    value={props.infoCliente?.nombre}
                  />
                </div>
                <div className='label-input'>
                  <label htmlFor='departamento' className='field-label m'>
                    Departamento
                  </label>
                  <SearchSelect
                    disabled={true}
                    placeholder='Actividad económica'
                    value={props.infoCliente?.departamento}
                    name='actividad'
                    data={departamentos}
                    keyNameText='valor'
                    keyNameValue='codigo'
                    onChange={(value: any) => {}}
                    defaultValue={null}
                  />
                </div>
              </div>
              <div className='w-layout-hflex h-inputs'>
                <div className='label-input'>
                  <label htmlFor='municipio' className='field-label m'>
                    Municipio
                  </label>
                  <SearchSelect
                    disabled={true}
                    placeholder='Actividad económica'
                    value={props.infoCliente?.municipio}
                    name='municipio'
                    data={municipios}
                    keyNameText='valor'
                    keyNameValue='codigo'
                    onChange={(value: any) => {}}
                    defaultValue={null}
                  />
                </div>
                <div className='label-input'>
                  <label htmlFor='direccion' className='field-label m'>
                    Dirección
                  </label>
                  <input
                    autoComplete='off'
                    type='text'
                    className='m text-field w-input'
                    name='direccion'
                    data-name=''
                    placeholder='Dirección'
                    id='direccion'
                    disabled={true}
                    maxLength={200}
                    value={props.infoCliente?.direccion}
                  />
                </div>
              </div>
              <div className='w-layout-hflex h-inputs'>
                <div className='label-input'>
                  <label htmlFor='email' className='field-label m'>
                    Correo electrónico
                  </label>
                  <input
                    autoComplete='off'
                    type='email'
                    className='m text-field w-input'
                    name='email'
                    data-name='Correo electrónico'
                    placeholder='Correo electrónico'
                    id='email'
                    disabled={true}
                    value={props.infoCliente?.email}
                  />
                </div>
                <div className='label-input'>
                  <label htmlFor='telefono' className='field-label m'>
                    Teléfono celular
                  </label>
                  <InputPhone
                    disabled={true}
                    value={props.infoCliente?.telefono}
                    onChange={() => {}}
                    onBlur={() => {}}
                    className='telefono-style'
                    name='telefono'
                  />
                </div>
              </div>
              <div className='w-layout-hflex h-inputs'>
                <div className='label-input'>
                  <label htmlFor='actividad' className='field-label m'>
                    Actividad
                  </label>
                  <SearchSelect
                    disabled={true}
                    placeholder='Actividad económica'
                    value={props.infoCliente?.codActividad}
                    name='actividad'
                    data={catalogoActividadEconomica}
                    keyNameText='codigo_nombre'
                    keyNameValue='codigo'
                    onChange={(value: any) => {}}
                    defaultValue={null}
                  />
                </div>
                <div className='label-input'>
                  <label htmlFor='nrc' className='field-label m'>
                    NRC
                  </label>
                  <input
                    autoComplete='off'
                    type='text'
                    className='m text-field w-input'
                    name='nrc'
                    data-name=''
                    placeholder='NRC'
                    id='nrc'
                    disabled={true}
                    maxLength={200}
                    value={props.infoCliente?.nrc}
                  />
                </div>
              </div>
              <div className='form-separator'></div>
              <div className='w-layout-hflex button-actions'>
                <button type='button' className='m button transparent w-inline-block' onClick={props.onClickCancel}>
                  <div>Cancelar</div>
                </button>
                <button autoFocus onClick={props.onClickConfirm} className='m button w-inline-block'>
                  <div>Confirmar</div>
                </button>
              </div>
            </form>
          </div>
        </ModalBase>
      )
}